import styled, { css } from 'styled-components';
import { scrollbarHide } from '@styles/variants/scrollbar';
import {
  PAGE_HASHTAG_TYPE,
  PAGE_HASHTAG_TYPE_VALUE,
} from '@typings/setting/pageTagType.interface';
import { motion } from 'framer-motion';

export const CountSpan = styled.span`
  font-weight: 500;
`;

export const maskingMap = {
  left: css`
    mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 5%
    );
  `,
  right: css`
    mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 1) 95%,
      rgba(0, 0, 0, 0) 100%
    );
  `,
  center: css`
    mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 5%,
      rgba(0, 0, 0, 1) 95%,
      rgba(0, 0, 0, 0) 100%
    );
  `,
};

export const TabUnderLine = styled.div<{ width?: number; left?: number }>`
  width: ${(props) => `${props.width}px` || '0px'};
  left: ${(props) => `${props.left}px` || '0px'};

  background-color: var(--primaryColor);
  height: 4px;
  position: absolute;
  bottom: 0;
  transition: all 0.3s;
  z-index: 0;
`;

export const TabNoAniUnderline = styled.div`
  background-color: var(--primaryColor);
  width: 100%;
  height: 4px;
  position: absolute;
  bottom: -10px;
  left: 0;
  transition: all 0.3s;
  z-index: 0;
`;

const fixedStyle = css`
  position: absolute;
  top: 0;
`;

export const TabWrapper = styled(motion.div)`
  display: grid;
  grid-template-rows: auto 1fr;
  width: 100%;
  min-width: 0;
  /* height: -webkit-fill-available; */
  height: 100%; // 꼭있어야함 없으면 드롭다운일떄 스크롤이안됨

  ${scrollbarHide}

  @media (max-width: 480px) {
    /* height: auto; */
  }
`;

const addBgStyle = css`
  border-radius: var(--cardBorderRadius);
  background-color: var(--cardBackgroundColor);
  border: var(--cardBorderWidth) var(--cardBorderType) var(--cardLineColor);
  padding: 16px;
  isolation: isolate;

  @media (max-width: 768px) {
    margin: 12px 0 32px;
    padding: 12px;
  }
`;

export const TabContents = styled(motion.div) <{
  overflowY?: 'auto' | 'unset';
  isBackground?: boolean | null;
}>`
  width: 100%;
  min-width: 0;
  height: 100%;
  position: relative;
  overflow-x: hidden;

  //채팅탭에서 스크롤을 유지하기 위해 꼭 필요!!
  overflow-y: ${({ overflowY }) => overflowY};

  ${scrollbarHide}

  ${({ isBackground }) => isBackground && addBgStyle};
`;

const tabBtnType = {
  [PAGE_HASHTAG_TYPE.HORIZONTAL]: css`
    scroll-behavior: smooth;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    ${scrollbarHide}
  `,
  [PAGE_HASHTAG_TYPE.VERTICAL]: css`
    scroll-behavior: smooth;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
    ${scrollbarHide}
  `,
  [PAGE_HASHTAG_TYPE.SPREAD]: css`
    display: flex;
    flex-wrap: wrap;
  `,
};

export const TabBtnWrapper = styled.div<{
  maskingdir?: 'right' | 'left' | 'center' | '';
  isFixed?: boolean;
  layout?: PAGE_HASHTAG_TYPE_VALUE;
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1;
  min-width: 0;

  ${scrollbarHide}

  // 탭에 스크롤 요소가 있을 때
  ${({ maskingdir }) => maskingdir && maskingMap[maskingdir]}
  ${({ layout }) => layout && tabBtnType[layout]}
`;

export const TabBtnContainer = styled.div<{
  isFixed?: boolean;
}>`
  width: 100%;
  min-width: 0;
  position: relative;
  overflow-x: auto;
  overflow-y: visible;
  display: flex;
  align-items: center;
  gap: 4px;
  ${({ isFixed }) => isFixed && fixedStyle}
  ${scrollbarHide}

  @media (max-width: 480px) {
    overflow-x: hidden;
  }
`;
